export var SUCCESS_API_EVENT = 'SUCCESS_EVENT';
export var ERROR_API_EVENT = 'ERROR_API_EVENT';
